import { gql } from "@apollo/client";

const ORDER_EXPIRY = gql`
  mutation orderExpiry($input: OrderExpirySetting) {
    orderExpiry(input: $input) {
      status
      data
      error
    }
  }
`;
export default ORDER_EXPIRY;
